import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/contratado";

/**
 * Classe de gerenciamento de chamadas da API do MedicoConselhoProfissional
 *
 * @class
 */
export default class MedicoConselhoProfissionalApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe MedicoConselhoProfissionalApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns registro do MedicoConselhoProfissional
   */
    lerRegistro(codMedicoConselhoProfissional: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codMedicoConselhoProfissional }
        });
    }

}